// export default class Communication{
//     constructor(title:string,communication?:Array<any>[]){
//         this.title = title;
//         (communication != null) ? this.communication = communication : new Array<any>();
//     }
//     public title: string;
//     public communication:Array<any> [] = [];
// }

export default class CommunicationWidgetDto {
    constructor();
    constructor(
      idCommunication?: string,
      text?: string,
      title?: string,
      creationDate?: Date,
      linkName?: string,
      linkUrl?: string,
      attachments?:Array<any>,
      isRead?:boolean,
      nameType?:string,
      idCategory?: string,
      nameCategory?:string,
      nameSubCategory?:string,
      //isActive?:boolean
      isMandatory?:boolean,
      isAcknowledgment?:boolean
    ) {
      this.idCategory = idCategory;
      this.idCommunication = idCommunication;
      this.text = text;
      this.title = title;
      this.creationDate = creationDate;
      this.linkName = linkName;
      this.linkUrl = linkUrl;
      (attachments) ? this.attachments = attachments : this.attachments = new Array<any>();
      this.isRead = isRead;
      this.nameType = nameType;
      this.readingConfirmationDate = this.readingConfirmationDate;
      this.nameCategory = nameCategory;
      this.nameSubCategory = nameSubCategory;
      this.isMandatory = isMandatory;
      //this.isActive = isActive;
      this.isAcknowledgment = isAcknowledgment;
    }
    public idCategory : string;
    public idCommunication: string;
    public text: string;
    public nameCategory: string;
    public nameSubCategory: string;
    public title: string;
    public isMandatory : boolean;
    public creationDate: Date;
    public linkName: string;
    public linkUrl: string;
    public nameType: string;
    public isRead: boolean;
    public attachments: Array<any> = new Array<any>();
    public readingConfirmationDate: Date = null;
    //public isActive: boolean;
    public isAcknowledgment: boolean;
  }
  